<template>
  <print-layout v-if="!loading">
    <div class="columns is-vcentered">
      <div class="column is-narrow">
        <img src="@/assets/logo-security.svg" alt style="height: 120px" />
      </div>
      <div class="column" style="font-size:12px">
        <p>
          <b>Openview Srl</b>
          <br />
          Via Renzo Zanellini, 15
          <br />
          Centro Direzionale Boma
          <br />
          46100 Mantova
          <br />
          P.IVA: 02505710208
        </p>
      </div>
      <div class="column is-narrow has-text-right">
        <!-- <img src="@/assets/graphisoft.png" alt /> -->
        Marco Scalari
        <br />
        375 5233855
        <br />
        marcos.sicurezza@gmail.com
      </div>
    </div>
    <div class="columns">
      <div class="column" style="font-size:12px">
        <p>
          <b>ID</b>
          {{ estimate.id }}
          <br />
          <b>Cliente</b>
          {{ customer.internal_id }}
          <br />
          <b>Data</b>
          {{ $moment(estimate.date).format("D/M/Y") }}
        </p>
        <p>
          <b>Oggetto</b>
          {{ estimate.name }}
        </p>
      </div>
      <div class="column" style="font-size:12px">
        <p>
          Spett.le
          <br />
          {{ customer.name }}
          <br />
          {{ customer.legal_address }}
          <br />
          {{ customer.legal_zip_code }} {{ customer.town }} ({{
            customer.legal_province
          }})
        </p>
      </div>
    </div>
    <div>
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>Codice</th>
            <th>Descrizione</th>
            <th>Qt.</th>
            <th>IVA</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="line in formattedLines" :key="line.id">
            <td>{{ line.product.code }}</td>
            <td>{{ line.description }}</td>
            <td>{{ line.amount }}</td>
            <td>{{ line.tax }}%</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="columns" style="margin-top: 10px">
      <div class="column" style="font-size:12px">
        <p>
          Condizioni di pagamento:
          {{ estimate.payment_method_display }}
        </p>
      </div>

      <!--<div class="column is-two-quarters has-text-right">
        <p>Imponibile</p>
        <p>IVA</p>
        <p>Totale</p>
      </div>-->
      <div class="column has-text-right" style="font-size:12px">
        <p>Imponibile: {{ totals.base.toFormat() }}</p>
        <p>IVA: {{ totals.tax.toFormat() }}</p>
        <p>Totale: {{ totals.final.toFormat() }}</p>
      </div>
    </div>
    <div class="columns" style="margin-top: 50px">
      <div class="column has-text-right" style="font-size:12px">
        Firma del cliente per accettazione:
        ..........................................................................
      </div>
    </div>
    <div class="columns" style="margin-top: 50px">
      <div class="column has-text-left">
        <p style="margin-top: 20px; white-space: pre">{{ estimate.notes }}</p>
      </div>
    </div>
  </print-layout>
</template>

<script>
import { get, call } from "vuex-pathify"
import store from "@/store"
import find from "lodash/find"
import cloneDeep from "lodash/cloneDeep"

import PrintLayout from "@/layouts/Print.vue"

export default {
  components: {
    PrintLayout
  },
  data() {
    return {
      loading: true
    }
  },
  computed: {
    customer: get("customers/customer"),
    estimate: get("estimates/estimate"),
    lines: get("estimateLines/estimateLines"),
    products: get("products/products"),
    formattedLines() {
      let lines = cloneDeep(this.lines)
      lines.forEach(line => {
        let product = find(this.products.results, product => {
          return product.id === line.product
        })
        line.product = product
      })
      return lines
    },
    totals() {
      let baseTotal = this.money(0)
      let taxTotal = this.money(0)
      this.formattedLines.forEach(line => {
        try {
          baseTotal = baseTotal.add(
            this.money(line.final_price).multiply(line.amount)
          )
          taxTotal = taxTotal.add(
            this.money(line.final_price)
              .multiply(line.amount)
              .percentage(line.tax)
          )
        } catch (TypeError) {}
      })
      return { base: baseTotal, tax: taxTotal, final: baseTotal.add(taxTotal) }
    }
  },
  beforeDestroy() {
    store.set("estimates/estimate", {})
    store.set("estimateLines/estimateLines", [])
    store.set("customers/customer", {})
    store.set("products/products", [])
  },
  async mounted() {
    this.loading = true
    await this.fetchEstimate(this.$route.params.id)
    await this.fetchCustomer(this.estimate.customer)
    await this.fetchEstimateLines(this.$route.params.id)
    await this.fetchProducts()
    this.loading = false
  },
  methods: {
    fetchEstimate: call("estimates/find"),
    fetchEstimateLines: call("estimateLines/all"),
    fetchCustomer: call("customers/find"),
    fetchProducts: call("products/all")
  }
}
</script>

<style lang="sass" scoped>
.table tr
    border: 1px solid #dbdbdb
.table td, .table th
    border: 1px solid #dbdbdb
    padding: 0.5em 0.25em
    vertical-align: top
    font-size: 12px
.table th
    text-align: left
nav
  margin-top: 2.1rem
.column.is-narrow:first-child
  padding-left: 0
</style>
